import React from "react";

import SchoolFooterContact from "../contact/SchoolFooterContact";
import SchoolFooterBip from "../bip/SchoolFooterBip";

import "./SchoolFooterInfoPanel.css";

const SchoolFooterInfoPanel = () => {
  return (
    <aside
        className="school-footer-info-panel"
        aria-label="Kontakt i Biuletyn Informacji Publicznej"
    >
        <div className="school-footer-info-panel__contact">
            <SchoolFooterContact />
        </div>

        <div className="school-footer-info-panel__bip">
            <SchoolFooterBip />
        </div>
    </aside>
  );
};

export default SchoolFooterInfoPanel;